// jshint esversion:6,asi:true
import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)

let actions = {
  loginByPassword: { // 用户登录
    'method': 'POST',
    'url': '/api/v1/auth/login_by_password'
  },
  loginByPhone: {
    'method': 'POST',
    'url': '/api/v1/auth/login_by_phone'
  },
  register: { // 用户注册
    'method': 'POST',
    'url': '/api/v1/auth/register'
  },
  session: { // 获取用户信息
    'method': 'GET',
    'url': '/api/v1/auth/session'
  },
  checkEmail: {
    'method': 'GET',
    'url': '/api/v1/auth/check_email'
  },
  checkPhone: {
    'method': 'GET',
    'url': '/api/v1/auth/check_user_phone'
  },
  emailCode: {
    'method': 'GET',
    'url': '/api/v1/auth/email_code'
  },
  phoneCode: {
    'method': 'GET',
    'url': '/api/v1/auth/phone_code'
  },
  registerByPhone: {
    'method': 'POST',
    'url': '/api/v1/auth/register_by_phone'
  },
  userRegister: {
    'method': 'POST',
    'url': '/api/v1/auth/register/user'
  },
  companyRegister: {
    'method': 'POST',
    'url': '/api/v1/auth/register/user'
  },
  registerByEmail: {
    'method': 'POST',
    'url': '/api/v1/auth/register_by_email'
  },
  thirdPhoneCode: {
    'method': 'GET',
    'url': '/api/v1/auth/3rd/phone_code'
  },
  thirdEmailCode: {
    'method': 'GET',
    'url': '/api/v1/auth/3rd/email_code'
  },
  linkByPhone: {
    'method': 'POST',
    'url': '/api/v1/auth/3rd/link_by_phone'
  },
  link: {
    'method': 'POST',
    'url': '/api/v1/auth/3rd/link'
  },
  linkByEmail: {
    'method': 'POST',
    'url': '/api/v1/auth/3rd/link_by_email'
  },
  sendVerifyCode: {
    'method': 'GET',
    'url': '/api/v1/auth/send_verify_code'
  },
  loginByCode: {
    'method': 'POST',
    'url': '/api/v1/auth/login_by_code'
  },
  initializeInfo: {
    'method': 'GET',
    'url': '/api/v1/auth/initialize{/code}'
  },
}

export default Vue.resource('/api/v1/auth/', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/auth.js